import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/first-order-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 496.2C115.3 496.2 7.8 388.7 7.8 256S115.3 15.8 248 15.8 488.2 123.3 488.2 256 380.7 496.2 248 496.2zM248 36.3C126.7 36.3 28.3 134.7 28.3 256S126.7 475.7 248 475.7 467.7 377.3 467.7 256 369.3 36.3 248 36.3zM248 467.5C131.2 467.5 36.5 372.8 36.5 256S131.2 44.5 248 44.5 459.5 139.2 459.5 256 364.8 467.5 248 467.5zM434.2 304.5A191.6-191.6 0 0 0 414.1 353.2L340 317.3 401.5 372.2A193.5-193.5 0 0 0 364.3 409.4L309.5 347.9 345.3 422.1A190.9-190.9 0 0 0 296.7 442.4L269.4 363.9 274.2 446.8C265.6 448 256.8 448.6 247.9 448.6S230.2 448 221.5 446.8L226.3 364.4 199.2 442.4A191.4-191.4 0 0 0 150.5 422.2L186.4 347.9 131.6 409.5A193.8-193.8 0 0 0 94.3 372.2L155.9 317.3 81.7 353.3A191.6-191.6 0 0 0 61.5 304.6L139.4 277.5 57.1 282.2C56 273.6 55.4 264.9 55.4 256 55.4 247 56 238.2 57.2 229.5L139.6 234.3 61.6 207.1A191.7-191.7 0 0 0 81.9 158.4L156.1 194.4 94.5 139.5A193.8-193.8 0 0 0 131.8 102.3L186.6 163.8 150.8 89.6A191.5-191.5 0 0 0 199.4 69.5L226.3 146.8 221.6 65.1C230.2 64 239 63.4 247.9 63.4S265.6 64 274.2 65.1L269.5 147.3 296.5 69.6C313.8 74.1 330.1 80.9 345.2 89.7L309.3 163.8 364.1 102.4A193.1-193.1 0 0 0 401.3 139.6L339.8 194.4 414 158.5A191.5-191.5 0 0 0 434.2 207.2L356.4 234.3 438.6 229.5C439.8 238.2 440.4 247 440.4 256 440.4 264.9 439.8 273.6 438.6 282.2L356.5 277.4 434.2 304.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/first-order-alt.js
// module id = rGgy
// module chunks = 144